import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeHeader } from '../components/ResumeHeader';
import { ResumeSummary } from '../components/ResumeSummary';
import { EngineeringHighlights } from '../components/EngineeringHighlights';
import { TechnicalExpertise } from '../components/TechnicalExpertise';
import { ExperienceSection } from '../components/ExperienceSection';
import { ProjectsSection } from '../components/ProjectsSection';
import { SkillsSection } from '../components/SkillsSection';
import { EducationSection } from '../components/EducationSection';
import { CertificationSection } from '../components/CertificationSection';

interface Props {
  resume: BuiltResume;
}

export function ProfessionalLayout({ resume }: Props) {
  return (
    <div className="resume-document resume-professional">
      <ResumeHeader contact={resume.contact} />
      <ResumeSummary summary={resume.summary} />
      <EngineeringHighlights highlights={resume.highlights} />
      <TechnicalExpertise expertise={resume.technicalExpertise} />
      <ExperienceSection experiences={resume.experiences} />
      <ProjectsSection projects={resume.projects} />
      <SkillsSection skills={resume.skills} />
      <EducationSection education={resume.education} />
      <CertificationSection certifications={resume.certifications} />
    </div>
  );
}
